export default __webpack_public_path__ + "static/media/srt.2e35300a.png";